import React from 'react';
import classNames from 'classnames';
import RoleTag from 'router/subrouters/DataRoom/subrouters/components/RoleTag';
import GroupUsersIcon from 'icons/GroupUsers.icon';

import './GroupPill.styles.scss';

type GroupPillProps = {
  className?: string;
  name: string;
  count: number;
  isPulsing?: boolean;
  onClick?: () => void;
};

const GroupPill: React.FC<GroupPillProps> = (props) => {
  const { className, name, count, isPulsing, onClick } = props;

  return (
    <RoleTag
      className={classNames(
        'group-pill',
        { 'group-pill--pulsing': isPulsing },
        className,
      )}
      onClick={onClick}
    >
      <span className="group-pill__name">{name}</span>
      <span className="group-pill__count">
        <GroupUsersIcon />
        {count}
      </span>
    </RoleTag>
  );
};

export default GroupPill;
